import $ from 'jquery';
import {getAppInst, getAppName} from "util/AppName";

const appName = getAppName();
const appinst = getAppInst();
if (!appName) {
	console.error("No application name defined");
} else {
	$(document).ajaxSend(function (event, jqXHR) {
		jqXHR.setRequestHeader('sisAppName', appName);
		if (appinst) jqXHR.setRequestHeader('appinst', appinst);
	});
}
$.ajaxSetup({cache: false});

$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
	if (jqxhr.status == 403) {
		// alert("Sorry, your session has expired. Please login again to continue");
		window.location.reload();
	}
});


window.sis = {
	...window.sis,
	$,
};